import { Component, OnInit } from '@angular/core';
declare var hbspt: any;
@Component({
  selector: "app-form-addnewsource",
  templateUrl: "./form-addnewsource.component.html",
  styleUrls: ["./form-addnewsource.component.scss"],
})
export class FormAddnewsourceComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {
    hbspt.forms.create({
      region: "na1",
      portalId: "22207066",
      formId: "4ec44b49-6b89-4b9b-bc75-c3eb6b2a76cf",
      target: "#hubspotForm",
    });
  }
}
